module.exports = __webpack_public_path__ + "img/icon13.2c4e2342.png";